import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { confirmAlert } from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { Card } from "components/Card/Card.jsx";
import SimpleReactValidator from "simple-react-validator";
import ThemeModal from '../../ThemeComponents/ThemeModal';
import { withRouter } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import { createOrderActions } from "../../../redux/actions/create-order-actions";
import { MdNavigateNext, MdNavigateBefore } from 'react-icons/md';
import BrandLogo from "./BrandLogo";
import TagLayout from "./TagLayout";
import LookupPO from "./LookupPO";
import downloadIcon from '../../../assets/img/download_icon.png';
import { Link } from "react-router-dom";
import $ from "jquery";

var cloneDeep = require('lodash.clonedeep');

class OrderProducts extends Component {
    constructor(props) {
        super(props);
        this.validatorBrand = new SimpleReactValidator();
        this.state = {
            //showModal: false,
            filtered: "",
            selectAddAll: false,
            submitted: false,
            pageSize: 200,
            selectedProducts: [],
            productQuantities: [],
            productsCanBeAddedToCart: [],
            productAttributes: [],
            orderAttributes: [],
            productsData: [],
            currentStep: null,
            page: 1,
            chosen_attributes: [],
            columnArrays: [],
            orderColumnArrays: [],
            allColumnsArrays: [],
            checkedProductsIds: [],
            checkedProducts: [],
        };
        this.check_all_ref = React.createRef();
        this.onlychecked=[];
    }

    refreshList = (page = 1) => {
        this.props
            .getProductsCall({
                filters: this.props.selectedFilterAttributes,
                brand: this.props.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.props.productAttributes,
                orderAttributes: this.props.orderAttributes,
                selectedProducts: this.state.selectedProducts,
                tag_layout: this.props.selectedTaglayout,
                page: page,
                sort: "",
                pageSize: this.state.pageSize,
                cart: this.props.cart
            })
            .then(response => {
                if (this.check_all_ref && this.check_all_ref.current)
                    this.check_all_ref.current.checked = false;
                this.setState({
                    ...this.state,
                    // productsData: this.markAlreadySelectedProducts(this.props.productsData),
                    productsData: this.props.productsData,
                    productAttributes: this.props.productAttributes,
                    orderAttributes: this.props.orderAttributes,
                });
            });
    }

    markAlreadySelectedProducts = (products = []) => {
        let ids = [...this.state.checkedProductsIds];
        let temp_prods = cloneDeep(products).map(item => {
            if (ids.includes(item.id)) {
                item.selected = true;
            }
            return item;
        });
        return temp_prods;
    }

    componentDidUpdate(prevProps) {
        // don't forget to compare props
        if (
            this.props.currentStep !== prevProps.currentStep &&
            this.props.currentStep === 3
        ) {
            this.props
                .getProductsCall({
                    filters: this.props.selectedFilterAttributes,
                    brand: this.props.selectedBrand,
                    filterTerm: this.state.filtered,
                    productAttributes: this.props.productAttributes,
                    orderAttributes: this.props.orderAttributes,
                    tag_layout: this.props.selectedTaglayout,
                    selectedProducts: [],
                    // selectedProducts: this.state.selectedProducts,
                    page: 1,
                    sort: "",
                    pageSize: this.state.pageSize,
                    cart: this.props.cart
                })
                .then(response => {
                    this.setState({
                        ...this.state,
                        productAttributes: this.props.productAttributes,
                        orderAttributes: this.props.orderAttributes,
                    }, () => {
                        const columnArrays = this.state.productAttributes.filter(col => col.show_on_grid).map(col => {
                            if (col.data_type === 'url') {
                                return {
                                    Header: col.grid_label,
                                    accessor: col.db_column,
                                    minWidth: 85,
                                    className: "action-center",
                                    Cell: ({ value, original }) => (
                                        <React.Fragment>
                                            <Link to={value} target="_blank" title="Download" download><img
                                                src={downloadIcon} alt='img' /></Link>
                                        </React.Fragment>
                                    )
                                };
                            } else {
                                return {
                                    Header: col.grid_label,
                                    accessor: col.db_column,
                                    minWidth: 85,
                                    className: "action-center"
                                };
                            }
                        });
                        const orderColumnArrays = this.state.orderAttributes.map(myCol => {
                            return {
                                Header: myCol.cart_label,
                                accessor: myCol.db_column,
                                minWidth: 85,
                                className: "action-center",
                                Cell: (col) => this.genTblInput(col, myCol)
                            };
                        });
                        const allColumnsArrays = [
                            {
                                Header: 'Prod Filter',
                                accessor: 'prod_filter',
                                className: "action-center",
                                show: true,
                            }
                            ,
                            ...columnArrays,
                            ...orderColumnArrays,
                            {
                                Header: (
                                    <React.Fragment>
                                        <label>
                                            <input
                                                type="checkbox"
                                                style={{
                                                    float: "left",
                                                    margin: "4px 6px",
                                                    width: '30px',
                                                    height: '30px',
                                                }}
                                                id="checkall"
                                                ref={this.check_all_ref}
                                                onChange={e => this.handleCheckStatusAll(e)}
                                            />
                                        </label>
                                        <div>
                                            {/* <span style={{ fontSize: "12px" }}>Add All</span> */}
                                            <span>
                                                <i
                                                    style={{
                                                        marginLeft: "4px"
                                                    }}
                                                    className="fa fa-shopping-cart"
                                                ></i>
                                            </span>
                                        </div>
                                    </React.Fragment>
                                ),
                                accessor: "id",
                                sortable: false,
                                className: "action-center",
                                Cell: ({ value, original, index }) => (
                                    <React.Fragment>
                                        <div>
                                            <label>
                                                <input
                                                    type="checkbox"
                                                    style={{
                                                        float: "left",
                                                        margin: "4px 6px",
                                                        width: '30px',
                                                        height: '30px',
                                                    }}
                                                    key={value}
                                                    id="check-single"
                                                    checked={this.state.productsData[index] ? this.state.productsData[index].selected : false}
                                                    onChange={e => this.selectItem(value, original, index, e)}
                                                />
                                            </label>
                                        </div>
                                    </React.Fragment>
                                )
                            }
                        ];
                        this.setState({
                            allColumnsArrays
                        })
                    });
                });
        }

        if (
            this.props.productsData !== prevProps.productsData &&
            this.props.currentStep === 3
        ) {
            this.setState({
                ...this.state,
                // productsData: this.markAlreadySelectedProducts(this.props.productsData),
                productsData: this.props.productsData
            });
        }
    }

    addCheckedProducts = (e) => {
        this.setState(
            {
                ...this.state,
                selectedProducts: [...new Set([...this.state.selectedProducts, ...this.state.checkedProductsIds])],
                chosen_attributes: this.state.checkedProducts
            },
            function () {
                this.props.addProductsToCart({
                    selectedProducts: this.state.selectedProducts,
                    onlychecked:[...new Set(this.onlychecked)],
                    chosen_attributes: this.state.chosen_attributes,
                    brand: this.props.selectedBrand,
                    selectedTaglayout: this.props.selectedTaglayout,

                    productAttributes: this.props.productAttributes,
                    orderAttributes: this.props.orderAttributes,
                    // productsData: this.state.productsData,
                    selectedFilters: this.props.selectedFilterAttributes,
                    filtersAttributes: this.props.filterAttributes,
                    mode: 'add'
                }).then(response => {
                    // this.setState(prevState => ({
                    //     selectedProducts: [],
                    //     chosen_attributes: [],
                    // }));
                    this.onlychecked=[];
                    this.props.refreshCartProducts();
                    this.refreshList(this.state.page);
                });
            }
        );
    }

    selectItem = (value, original, index, e) => {
        let checked = e.target.checked;
        let allow_quantity_increase = this.props.selectedTag ? this.props.selectedTag.allow_quantity_increase : null;
        if (checked) {
            //  console.log('item in',value)
            this.onlychecked.push(value)
            let selected_pids = [];
            let chosen_atts = [];
            let isAdjustAttributePresent = false;
            let validation_failed = false;
            let quantity_check_failed = false;
            const product = this.state.productsData.find(
                item => item.id === value
            );
            let one_item_added = false;
            this.props.orderAttributes.forEach((order_attribute) => {
                if (order_attribute.adjust_product_attribute !== null) {
                    isAdjustAttributePresent = true;
                    if (product[order_attribute.adjust_product_attribute_name] < Number(product[order_attribute.db_column]) && this.props.selectedTag && !allow_quantity_increase) {
                        validation_failed = true;
                        quantity_check_failed = true;
                    } else if (Number(product[order_attribute.db_column]) > 0) {
                        one_item_added = true;
                        selected_pids = [...selected_pids, value];
                        chosen_atts = [...chosen_atts, original];
                    }
                } else {
                    if (Number(product[order_attribute.db_column]) > 0) {
                        one_item_added = true;
                        selected_pids = [...selected_pids, value];
                        chosen_atts = [...chosen_atts, original];
                    } else {
                        validation_failed = true;
                    }
                }
            });
            if (validation_failed && !one_item_added) {
                let msg;
                if (quantity_check_failed) {
                    msg = "Order quantity cannot be more than available quantity!";
                }
                else if (!one_item_added) {
                    msg = "At least one quantity should be greater than 0!";
                }
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                                description={msg} />
                        )
                    }
                })
                return;
            } else {
                if (selected_pids.length === 0 && isAdjustAttributePresent === true) {
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                                    description="Order quantity cannot be less than quantity!" />
                            )
                        }
                    });

                    return;
                }
            }
        }
        //
        if(!checked){
            // console.log('item out',value)
            this.onlychecked=this.onlychecked.filter(item => item !== value);
            //  console.log('this.onlychecked', this.onlychecked)
        }
        let temp_prods = cloneDeep(this.state.productsData);
        temp_prods[index].selected = checked;
        let checkedProdsIds = temp_prods.filter(item => item.selected).map(filtered => filtered.id);
        let checkedProds = temp_prods.filter(item => item.selected);

        this.setState({
            checkedProductsIds: [...this.state.checkedProductsIds, ...checkedProdsIds],
            checkedProducts: [...this.state.checkedProducts, ...checkedProds],
            productsData: temp_prods
        }, () => {
            let unique_checked_ids = [...new Set(this.state.checkedProductsIds)]
            let filter_unique_checked_ids = [...unique_checked_ids]
            let unique_checked = [...new Map(this.state.checkedProducts.map(item =>
                [item['id'], item])).values()];
            let filter_unique_checked = [...unique_checked];
            if (!checked) {
                filter_unique_checked = unique_checked.filter(item => {
                    if (value !== item.id) {
                        return true;
                    }
                })
                filter_unique_checked_ids = unique_checked_ids.filter(item => {
                    if (value !== item) {
                        return true;
                    }
                })
            }
            this.setState({
                checkedProductsIds: filter_unique_checked_ids,
                checkedProducts: filter_unique_checked,
            })
        })
        //
        return;
    };

    pageChangeNavigation = page => {
        if (this.check_all_ref && this.check_all_ref.current)
            this.check_all_ref.current.checked = false;
        // ? doing this te remove teh already cheked products
        this.setState({
            checkedProductsIds: [],
            checkedProducts: [],
        })
        this.productsPaginationData(page, this.state.filtered, "", this.state.pageSize);
    };

    filterChange = e => {
        const value = e.target.value;
        this.setState({ filtered: e.target.value }, function () {
            this.props.getProductsCall({
                filters: this.props.selectedFilterAttributes,
                brand: this.props.selectedBrand,
                filterTerm: value,
                productAttributes: this.props.productAttributes,
                orderAttributes: this.props.orderAttributes,
                tag_layout: this.props.selectedTaglayout,
                selectedProducts: this.state.selectedProducts,
                page: this.props.current_page,
                sort: "",
                pageSize: this.state.pageSize,
                cart: this.props.cart
            })
                .then(response => {
                    this.setState({
                        ...this.state,
                        productAttributes: this.props.productAttributes,
                        orderAttributes: this.props.orderAttributes,
                        //productsData: this.props.productsData
                    });
                });
        });
    };

    productsPaginationData = (page, filter, sort, pageSize) => {
        this.setState({ pageSize, page }, () => {
            this.props.getProductsCall({
                filters: this.props.selectedFilterAttributes,
                brand: this.props.selectedBrand,
                filterTerm: this.state.filtered,
                productAttributes: this.props.productAttributes,
                tag_layout: this.props.selectedTaglayout,
                orderAttributes: this.props.orderAttributes,
                selectedProducts: this.state.selectedProducts,
                page: this.state.page,
                sort,
                pageSize,
                cart: this.props.cart
            }).then(response => {
                this.setState({
                    ...this.state,
                    // productsData: this.markAlreadySelectedProducts(this.props.productsData),
                    productsData: this.props.productsData
                });
            });
        });
    };

    handleCheckStatusAll = e => {
        let allow_quantity_increase = this.props.selectedTag ? this.props.selectedTag.allow_quantity_increase : true;
        if ($("#checkall").prop("checked") === true) {
            let pids = [];
            let selected_pids = [];
            let validatedSelectedProducts = [];
            let chosen_atts = {};

            pids = this.state.productsData.map(p => p.id);

            let validation_failed = false;

            pids.forEach((prdId, idx) => {
                const product = this.state.productsData.find(
                    item => item.id === prdId
                );
                this.props.orderAttributes.forEach(obj => {
                    if (obj.adjust_product_attribute !== null) {
                        if (product[obj.adjust_product_attribute_name] < parseInt(product[obj.db_column]) && !allow_quantity_increase) {
                            validation_failed = true;
                        }

                        if (parseInt(product[obj.db_column]) > 0) {
                            selected_pids = [...selected_pids, prdId];
                            // chosen_atts = [...chosen_atts, this.state.productsData[idx]];
                            chosen_atts[prdId] = this.state.productsData[idx];
                            validatedSelectedProducts.push(product);
                        }
                    } else {
                        if (parseInt(product[obj.db_column]) > 0) {
                            selected_pids = [...selected_pids, prdId];
                            chosen_atts[prdId] = this.state.productsData[idx];
                            validatedSelectedProducts.push(product);
                            // chosen_atts = [...chosen_atts, this.state.productsData[idx]];
                        }
                    }
                });
            });

            if (validation_failed) {
                $("#checkall").prop("checked", false);
                if (this.check_all_ref && this.check_all_ref.current)
                    this.check_all_ref.current.checked = false;
                confirmAlert({
                    customUI: ({ onClose }) => {
                        return (
                            <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                                description="Order quantity cannot be more than available quantity!" />
                        )
                    }
                })
            } else {
                if (selected_pids.length === 0) {
                    confirmAlert({
                        customUI: ({ onClose }) => {
                            return (
                                <Confirmalertfordelete msgType="warning" onClosePro={onClose} header="Validation Error!"
                                    description="Atleast one product's Order quantity should be greater than zero!" />
                            )
                        }
                    });
                    return;
                }

                let chosen_array = Object.values(chosen_atts);
                let temp_prods = [...this.state.productsData].map(prd => {
                    const prod = { ...prd };
                    if (selected_pids.includes(prd.id)) {
                        prod.selected = true;
                    } else {
                        prod.selected = false;
                    }
                    return prod;
                });
                // if (this.check_all_ref && this.check_all_ref.current)
                //     this.check_all_ref.current.checked = true;
                this.onlychecked=[...selected_pids]
                this.setState(
                    {
                        ...this.state,
                        // selectedProducts: [...this.state.selectedProducts, ...selected_pids],
                        checkedProductsIds: [...selected_pids],
                        checkedProducts: [...validatedSelectedProducts],
                        chosen_attributes: [...chosen_array],
                        productsData: [...temp_prods],
                        selectAddAll: true,
                    },
                    // function () {
                    //     this.props.addProductsToCart({
                    //         selectedProducts: this.state.selectedProducts,
                    //         chosen_attributes: chosen_array,
                    //         brand: this.props.selectedBrand,
                    //         selectedTaglayout: this.props.selectedTaglayout,

                    //         productAttributes: this.props.productAttributes,
                    //         orderAttributes: this.props.orderAttributes,
                    //         // productsData: this.state.productsData,
                    //         selectedFilters: this.props.selectedFilterAttributes,
                    //         filtersAttributes: this.props.filterAttributes,
                    //         mode: 'add-all'
                    //     }).then(response => {
                    //         // this.setState(prevState => ({
                    //         //     selectedProducts: [],
                    //         //     chosen_attributes: [],
                    //         // }));
                    //         this.props.returnState(false);
                    //         this.props.refreshCartProducts();
                    //         this.refreshList(this.state.page);
                    //     });
                    // }
                );
            }
        } else {
            this.onlychecked=[]
            let temp_prods = [...this.state.productsData].map(prd => {
                return {
                    ...prd,
                    selected: false,
                }
            });
            if (this.check_all_ref && this.check_all_ref.current)
                this.check_all_ref.current.checked = false;
            this.setState(
                {
                    ...this.state,
                    selectedProducts: [],
                    chosen_attributes: [],
                    productsData: [...temp_prods],
                    selectAddAll: false,
                },
                // function () {
                //     this.props.addProductsToCart({
                //         selectedProducts: this.state.selectedProducts,
                //         chosen_attributes: this.state.chosen_attributes,
                //         brand: this.props.selectedBrand,
                //         selectedTaglayout: this.props.selectedTaglayout,

                //         productAttributes: this.props.productAttributes,
                //         orderAttributes: this.props.orderAttributes,
                //         // productsData: this.state.productsData,
                //         selectedFilters: this.props.selectedFilterAttributes,
                //         filtersAttributes: this.props.filterAttributes,
                //         mode: 'remove-all'
                //     }).then(response => {
                //         this.props.refreshCartProducts();
                //         this.refreshList(this.state.page);
                //     });
                // }
            );
        }
    };

    changeHandler = (e, id, index) => {
        e.preventDefault();
        // !
        const name = e.target.name;
        let productsData = cloneDeep(this.state.productsData);
        let item = { ...productsData[index] };
        item[name] = e.target.value;
        productsData[index] = item;
        const value = e.target.value;

        this.setState({ productsData }, () => {

            if (value > 0) {
                this.setState({
                    ...this.state,
                    productsCanBeAddedToCart: [...this.state.productsCanBeAddedToCart, item.id]
                },
                    () => {
                        $("#" + name + "-" + index).focus();

                        // if (this.state.selectedProducts.some(prdid => item.id === prdid)) {
                        //     this.props.updateCartProduct({
                        //         product: item,
                        //         cart: this.props.cart,
                        //         brand: this.props.selectedBrand,
                        //         orderAttributes: this.props.orderAttributes,
                        //     }).then(response => {
                        //         $("#" + name + "-" + index).focus();
                        //     });
                        // }

                    })
            } else {
                this.setState({
                    ...this.state,
                    productsCanBeAddedToCart: this.state.productsCanBeAddedToCart.filter(id => id !== item.id)
                },
                    () => {
                        $("#" + name + "-" + index).focus();
                    })
            }

        });
    };

    getValue = id => {
        const qty_row = this.state.productQuantitiesToOrder.filter(
            item => item.product_id === id
        );

        return qty_row.quantity;
    };

    addNewTagLayout = () => {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    genTblInput = (col, myCol) => {
        const dataType = myCol.data_type === 'integer' ? 'number' : 'text';
        let allow_quantity_increase = this.props.selectedTag ? this.props.selectedTag.allow_quantity_increase : null;
        if (myCol.is_quantity_attribute && myCol.adjust_product_attribute) {
            const adjustableAttribute = this.state.productAttributes.find(item => item.id === myCol.adjust_product_attribute);
            // ! this is the ordered qty
            let maxValueAllowed = 9999999;
            if (allow_quantity_increase == 0) {
                maxValueAllowed = col.original[adjustableAttribute ? adjustableAttribute.db_column : ''];
            }
            return (<div>
                {
                    <input
                        className="form-control"
                        type={'text'}
                        // type={dataType}
                        style={{ width: "60px", fontSize: "12px" }}
                        onChange={e =>
                            this.changeHandler(e, col.original.id, col.index)
                        }
                        value={col.value}
                        name={myCol.db_column}
                        id={`${myCol.db_column}-${col.index}`}
                        min="1"
                        max={maxValueAllowed}
                    />
                }
            </div>
            );
        } else {
            return (<div>
                {
                    <input
                        className="form-control"
                        type={'text'}
                        style={{ width: "60px", fontSize: "12px" }}
                        onChange={e =>
                            this.changeHandler(e, col.original.id, col.index)
                        }
                        value={col.value}
                        name={myCol.db_column}
                        id={`${myCol.db_column}-${col.index}`}
                        min='0'
                    />
                }
            </div>
            );
        }

    }

    paginationButtons = () => {
        return <div
            className="customPagination flexElem alignCenter spaceBetween">
            <div className="flexElem alignCenter spaceBetween">
                <button
                    type="button"
                    disabled={
                        this.props
                            .current_page ===
                        1
                    }
                    className="paginationBtn form-control"
                    onClick={() =>
                        this.pageChangeNavigation(
                            this
                                .props
                                .current_page -
                            1
                        )
                    }
                >
                    Previous Page
                </button>
            </div>
            <div className="flexElem alignCenter spaceBetween">
                Page{" "}
                {
                    this.props
                        .current_page
                }{" "}
                of{" "}
                {
                    this.props
                        .pages
                }
            </div>
            <div className="flexElem alignCenter spaceBetween">
                <button
                    disabled={
                        this.props
                            .current_page ===
                        this.props
                            .pages
                    }
                    type="button"
                    className="paginationBtn form-control"
                    onClick={() =>
                        this.pageChangeNavigation(
                            this
                                .props
                                .current_page +
                            1
                        )
                    }
                >
                    Next Page
                </button>
            </div>
        </div>
    }

    render() {
        const { filtered } = this.state;
        const { pages, loading } = this.props;

        const columns = [
            {
                Header: "States Listing",
                headerClassName: "headerPagination",
                columns: this.state.allColumnsArrays
            }
        ];
        return !this.props.listOnly ? (
            <React.Fragment>

                {/* <pre>{JSON.stringify(this.state.selectedProducts, null, 2)}</pre> */}

                <Grid fluid>
                    <Row>
                        {this.props.showListOnly === 'false' &&
                            <Col md={12}>
                                <div className="flexElem respFlex spaceBetween respFlex">
                                    <div className="mb-lg">
                                        <div className="brandInfo flexElem respFlex alignCenter">
                                            {
                                                this.props.selectedBrand &&
                                                <BrandLogo brand={this.props.selectedBrand} customClasses="ml-md text_16" />
                                            }
                                        </div>
                                    </div>

                                    <div style={{
                                        paddingTop: '86px', paddingRight: '15px'
                                    }}>
                                        {this.props.tags.length > 0 &&
                                            <button type="button" onClick={() => this.props.goToStep(
                                                this.props.filterAttributes.length === 0 ? 2 : this.props.prevStepNum
                                            )} className="customBtn btnBlack m-md btn-lg">Select Next Tag</button>
                                        }
                                    </div>
                                </div>
                            </Col>
                        }

                        <Col md={12}>
                            {this.props.filterAttributes.length > 0 &&
                                <LookupPO
                                    selectedBrand={this.props.selectedBrand}
                                    selectedTag={this.props.selectedTag}
                                    orderSteps={this.props.orderSteps}
                                    prevStepNum={this.props.prevStepNum}
                                    nextStepNum={this.props.prevStepNum}
                                    filterAttributes={this.props.filterAttributes}
                                    getLookupState={this.props.getLookupState}
                                    selectedFilterAttributes={
                                        this.props.selectedFilterAttributes
                                    }
                                    productAttributes={this.props.productAttributes}
                                    showFiltersOnly={true}
                                    resetLookupState={this.props.resetLookupState}
                                    refreshList={this.refreshList}
                                />
                            }
                            <Card
                                plain
                                noPaddingsMargins
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    {!this.props.showListOnly === 'true' &&
                                                        <h3
                                                            style={{
                                                                textAlign: "center",
                                                                fontWeight: "500"
                                                            }}
                                                        >
                                                            Create Order
                                                        </h3>
                                                    }
                                                    <form>
                                                        <div className="row">
                                                            {!this.props.showListOnly === 'true' &&
                                                                <div className="col-md-12">
                                                                    <div className="flexElem alignCenter spaceBetween">
                                                                        <div
                                                                            style={{
                                                                                paddingRight:
                                                                                    "50px"
                                                                            }}
                                                                        >
                                                                            <h4 className="mb-xs">
                                                                                {
                                                                                    "Enter Quantity to Order Products"
                                                                                }
                                                                            </h4>
                                                                            <div>
                                                                                {
                                                                                    "Following PO/Styles match your criteria. Please enter quantities to order desired products and add them to the cart"
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className="searchBox">
                                                                            <input
                                                                                type="text"
                                                                                placeholder="Search Products"
                                                                                className="form-control"
                                                                                onChange={
                                                                                    this
                                                                                        .filterChange
                                                                                }
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {this.props.showListOnly === 'false' &&
                                                                <div className="stepsNav mt-lg">
                                                                    {
                                                                        <div className="text-center">
                                                                            <button type="button"
                                                                                onClick={() => this.props.goToStep(
                                                                                    this.props.filterAttributes.length === 0 ? 2 : this.props.prevStepNum
                                                                                )}
                                                                                className="stepNav prev">
                                                                                <MdNavigateBefore />
                                                                            </button>
                                                                            <span className="display_ib mt-xs">Prev</span>
                                                                        </div>
                                                                    }

                                                                    {this.state.selectedProducts.length > 0 &&
                                                                        <div className="text-center">
                                                                            <button type="button" onClick={this.props.nextStep}
                                                                                className="stepNav next"><MdNavigateNext />
                                                                            </button>
                                                                            <span className="display_ib mt-xs">Next</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            }

                                                            <div className="clearfix"></div>
                                                            <div>
                                                                <button type="button" onClick={this.addCheckedProducts}
                                                                    className="customBtn btnBlack m-md btn-lg">Add
                                                                    Selected Items
                                                                </button>
                                                            </div>
                                                            <div
                                                                className={"mt-xlg" + (this.props.showListOnly === 'true' ? " no-margin" : "")}>
                                                                <ReactTable
                                                                    noDataText="No matching product found"
                                                                    data={
                                                                        this.state
                                                                            .productsData
                                                                    }
                                                                    pages={pages}
                                                                    loading={
                                                                        loading
                                                                    }
                                                                    columns={
                                                                        columns
                                                                    }
                                                                    filtered={
                                                                        filtered
                                                                    }
                                                                    defaultPageSize={
                                                                        10
                                                                    }
                                                                    style={{
                                                                        fontSize: '12px'
                                                                    }}
                                                                    className="resetTable listing responsive"
                                                                    showPagination={false}
                                                                    manual
                                                                />
                                                                {this.paginationButtons()}

                                                            </div>
                                                        </div>

                                                        {this.props.showListOnly === 'false' &&
                                                            <div className="stepsNav mt-lg">
                                                                {
                                                                    <div className="text-center">
                                                                        <button type="button"
                                                                            onClick={() => this.props.goToStep(
                                                                                this.props.filterAttributes.length === 0 ? 2 : this.props.prevStepNum
                                                                            )}
                                                                            className="stepNav prev"><MdNavigateBefore />
                                                                        </button>
                                                                        <span className="display_ib mt-xs">Prev</span>
                                                                    </div>
                                                                }

                                                                {this.state.selectedProducts.length > 0 &&
                                                                    <div className="text-center">
                                                                        <button type="button" onClick={this.props.nextStep}
                                                                            className="stepNav next"><MdNavigateNext />
                                                                        </button>
                                                                        <span className="display_ib mt-xs">Next</span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </form>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>

                <ThemeModal title="Select Next Tag" hide={() => {
                    this.setState({ showModal: !this.state.showModal })
                }} show={this.state.showModal} size="full">
                    <div className="mt-xlg">
                        <TagLayout
                            tags={this.props.tags}
                            tagsPages={this.props.tagsPages}
                            tagsCurrentPage={this.props.tagsCurrent_page}
                            showTagListOnly="true"

                            tagsFilter={this.props.tagsFilter}
                            selectedTaglayoutFunction={this.props.selectedTaglayoutFunction}
                            onTagLayoutsPageChange={this.props.onTagLayoutsPageChange}
                            onTagLayoutsFilterChange={this.props.onTagLayoutsFilterChange}
                        />
                    </div>
                </ThemeModal>

            </React.Fragment>
        ) : (
            <ReactTable
                noDataText="No user found"
                data={this.state.productsData}
                pages={pages}
                loading={loading}
                columns={columns}
                filtered={filtered}
                defaultPageSize={10}
                className="resetTable listing responsive"
                pageData={this.productsPaginationData}
                manual
                onFetchData={(state, instance) => {
                    var sort =
                        state.sorted.length === 0
                            ? ""
                            : state.sorted[0].id +
                            ",desc:" +
                            state.sorted[0].desc;
                    state.pageData(
                        state.page + 1,
                        state.filtered,
                        sort,
                        state.pageSize
                    );
                }}
            />
        );
    }
}

OrderProducts.defaultProps = {
    refreshCartProducts: () => {
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getProductsCall: data => {
            if (data.brand !== null) {
                return dispatch(createOrderActions.getProducts(data));
            }
        },
        addProductsToCart: data => {
            return dispatch(createOrderActions.addProductsToCart(data));
        },
        updateCartProduct: data => {
            return dispatch(createOrderActions.updateCartProduct(data));
        }
    };
};

function mapStateToProps(state) {
    const {
        productsData,
        productsInCart,
        pages,
        current_page,
        total_orders
    } = state.createOrdersReducer;
    return {
        productsData,
        pages,
        current_page,
        total_orders,
        productsInCart
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(OrderProducts)
);



// WEBPACK FOOTER //
// ./src/components/Admin/Order/OrderProducts.jsx